import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Ghost from '@/images/Ghost.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { Card } from './Card';

const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
    margin-block-start: 32px;
    margin-block-end: 11px;
`;

const SubTitle = styled.span`
    color: ${({ theme }) => theme.colors.black[800]};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
`;

export const NotFound = () => {
    const theme = useTheme();

    return (
        <Card>
            <MaskedIcon src={Ghost} color={theme.colors.secondary.main} size="52px" />
            <Title>We couldn't find what you’re looking for</Title>
            <SubTitle>Please try again later</SubTitle>
        </Card>
    );
};
